import { createEntityCollectionStore } from '@recruitee/ngrx';

import { CountryRegionEntity } from './regions.types';

const {
  actions: { fetchOne, fetchOneSuccess },
  selectors: { byId: byCountyCode, isLoaded, isFailed, isPending, error },
  namespace,
  reducer,
} = createEntityCollectionStore<CountryRegionEntity>()('CountryRegion');

const RegionActions = { fetchOne, fetchOneSuccess };
const RegionSelectors = {
  isLoaded,
  byCountyCode,
  error,
  isFailed,
  isPending,
};

export { RegionActions, RegionSelectors, namespace as RegionNamespace, reducer as RegionReducer };
